import { memo, MutableRefObject } from 'react'
import { TLastValuesDataRef } from '@/services/data/data.types.ts'
import { ITableWidget } from '@/pages/Dashboards/dashboards.types.ts'
import { useRecoilValue } from 'recoil'
import parametersSelectors from '@/pages/Parameters/parameters.selectors.ts'
import css from './tableChart.module.css'
import equipmentSelectors from '@/pages/Equipment/equipment.selectors.ts'
import equipmentUtils from '@/pages/Equipment/equipment.utils.ts'
import parametersUtils from '@/pages/Parameters/parameters.utils.ts'
import cn from '@/utils/cn.ts'

interface IProps {
  dataRef: MutableRefObject<TLastValuesDataRef>
  widget: ITableWidget

  // Prop для перерендера дочернего компонента родителем
  updateCounter: number
}

const TableChart = (props: IProps) => {
  const parametersMap = useRecoilValue(parametersSelectors.getParametersMap)
  const unitPrefixesMap = useRecoilValue(parametersSelectors.getUnitsPrefixesMap)
  const unitsMap = useRecoilValue(parametersSelectors.getUnitsMap)
  const equipmentMap = useRecoilValue(equipmentSelectors.getEquipmentMap)

  const renderTableRows = () => {
    const rows = []

    for (const equipmentId of props.widget.configuration.settings.equipment) {
      rows.push(
        <p key={equipmentId} className={cn(css.item, 'text-nm')}>
          {equipmentUtils.getEquipmentAddress(equipmentMap[equipmentId]?.location)}
        </p>
      )

      for (const dataRow of props.widget.configuration.settings.dataRows) {
        const value = props.dataRef.current?.[equipmentId]?.[dataRow.parameterId]
        if (Number.isNaN(value)) {
          rows.push(
            <p key={equipmentId + dataRow.parameterId} className={cn(css.item, 'text-nm')}>
              -
            </p>
          )
        } else {
          rows.push(
            <p className={cn(css.item, 'text-nm')} key={equipmentId + ' ' + dataRow.parameterId}>
              {parametersUtils.formatParameterValue({
                parameter: parametersMap[dataRow.parameterId],
                unitsMap,
                unitPrefixesMap,
                value: props.dataRef.current?.[equipmentId]?.[dataRow.parameterId],
              })}
            </p>
          )
        }
      }
    }

    return rows
  }

  const renderTable = () => {
    return (
      <div
        className={css.table}
        style={{
          gridTemplateColumns: `200px repeat(${props.widget.configuration.settings.dataRows.length}, 125px)`,
          gridTemplateRows: `repeat(${props.widget.configuration.settings.equipment.length + 1}, 100px)`,
        }}
      >
        <div className={css.item} />
        {props.widget.configuration.settings.dataRows.map((r, index) => (
          <p className={cn(css.item, 'text-nm')} key={index}>
            {r.title || parametersMap[r.parameterId]?.name}
          </p>
        ))}
        {renderTableRows()}
      </div>
    )
  }

  return <div className={css.wrapper}>{renderTable()}</div>
}

export default memo(TableChart)
